module.exports = __webpack_public_path__ + "img/boxed-19.8fe78e17.jpg";